<template>
    <div class="operative">
        <div class="img">
            <div  v-for="(value,index) in list" :key="index">
                <img :src="value.img" alt="">
            </div>
        </div>
        <!-- <div class="page">
            <a-pagination v-model="current" :total="50" showLessItems />
        </div>   -->
        
    </div>
</template>
<script>
export default {
    name:"operative",
    data(){
        return{
            apiUrl:window.g.apiUrl,
            list:[
                {img:require('../assets/logo1.png')},
                {img:require('../assets/logo2.png')},
                {img:require('../assets/logo3.png')},
                {img:require('../assets/logo4.png')},
                {img:require('../assets/logo5.png')},
                {img:require('../assets/logo6.png')},
                {img:require('../assets/logo7.png')},
                {img:require('../assets/logo8.png')},
                {img:require('../assets/logo9.png')},
                {img:require('../assets/logo10.png')},
                {img:require('../assets/logo11.png')},
                {img:require('../assets/logo12.png')},
                {img:require('../assets/logo13.png')},
                {img:require('../assets/logo14.png')},
                {img:require('../assets/logo15.png')},
                {img:require('../assets/logo16.png')},
                {img:require('../assets/logo17.png')},
                {img:require('../assets/logo18.png')},
            ]
        }
    }
}
</script>
<style lang="stylus" scoped>
.operative
    padding:30px;
    .img
        display:flex;
        justify-content:space-between;
        width:100%;
        flex-wrap:wrap ;
        border-left:1px dotted #ddd;
        border-top:1px dotted #ddd;
        div
            border-bottom:1px dotted #ddd;
            border-right:1px dotted #ddd
            width:33.33%
</style>